import React from 'react';
import Modal from 'react-bootstrap/Modal';

import closeIcon from '../../assets/images/closeIcon.svg';

import FilledButton from '../../components/Buttons/FilledButton';
import classes from './styles.module.scss';

export default function MultiButtonDialogModal({
  show,
  handleClose,
  buttons,
  title,
  description,
  hideCloseButton = false,
}) {
  return (
    <Modal
      show={show}
      centered
      contentClassName={classes.MultiButtonDialogModal}
      dialogClassName={classes.dialog}
      backdropClassName={classes.backdrop}
    >
      {!hideCloseButton && (
      <i 
        className={classes.closeIcon} 
        onClick={(event) => {
          event.stopPropagation();
          handleClose();
        }}
        role="button"
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleClose();
          }
        }}
      >
        <img src={closeIcon} alt="Close" />
      </i>
      )}
      <div onClick={(event) => event.stopPropagation()}>
        <div className={classes.content}>
          <h2 className={classes.title}>{title}</h2>
          {description && <p className={classes.description}>{description}</p>}

          <div className={classes.buttonsContainer}>
            {buttons.map((button) => (
              <FilledButton
                onClick={(event) => {
                  event.stopPropagation();
                  button.handleClick();
                  handleClose();
                }}
                isDisabled={button.disabled}
                key={button.title}
                className={classes.button}
                color={button.color}
                width={263}
                data-testid={button.testId}
              >
                {button.title}
              </FilledButton>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
}
